import React, {Component, Fragment} from "react";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import {Card, Button, Popconfirm, Divider, message, notification, InputNumber} from "antd";
import StandardTable from "../../components/StandardTable";
import FormModal from "../../components/FormModal";
import * as api from "../../api/factory";
import Select from "../../components/Select";

class Factory extends Component {

    columns = [
        {
            title: 'ID',
            dataIndex: 'id'
        },
        {
            title: '编号',
            dataIndex: 'no',
        },
        {
            title: '名称',
            dataIndex: 'name',
        },
    ];

    dataTable = undefined

    state = {
        modalVisible: false,
        modalRecord: {},
        modalSaving: false
    };

    modifyFields = [
        {
            dataIndex: 'id',
            visible: false
        },
        {
            title: '编号',
            dataIndex: 'no',
            rules: [{
                required: true, message: '请输入编号',
            }],
        },
        {
            title: '名称',
            dataIndex: 'name',
            rules: [{
                required: true, message: '请输入名称',
            }],
        },
    ];

    handleModalShow = (record = {}) => {
        this.setState({
            modalVisible: true,
            modalRecord: record,
        })
    };

    handleModalOk = (fieldsValue) => {
        this.setState({
            modalSaving: true,
        });
        api.modifyCompany({...fieldsValue}).then(() => {
            this.setState({
                modalSaving: false,
                modalVisible: false
            });
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({
                modalSaving: false,
            });
        })
    };

    render() {
        return (
            <PageHeaderLayout title={'工厂管理'}>
                <Card>
                    <div style={{marginBottom: 10}}>
                        <Button type={"primary"} onClick={() => this.handleModalShow()}>新增</Button>
                    </div>
                    <StandardTable columns={this.columns}
                                   rowKey={'id'}
                                   url={'/api/factory/'}
                                   ref={(table) => this.dataTable = table}
                    />
                </Card>
                <FormModal visible={this.state.modalVisible}
                           confirmLoading={this.state.modalSaving}
                           record={this.state.modalRecord}
                           fields={this.modifyFields}
                           onOk={this.handleModalOk}
                           onCancel={() => this.setState({modalVisible: false})}
                />
            </PageHeaderLayout>
        )
    }


}

export default Factory;
